import React, { useEffect, useState } from "react";
import styles from "../pages copy/Styles/GeneratePartnerCode.module.scss";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { FormHelperText } from "@mui/material";
import StageLayout from "../Layouts/StageLayout";
import {
  GeneratePartnerCodeAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared copy/APICalls";
import { IGeneratePartnerCode } from "../shared copy/dtos";
import routesData from "../shared copy/routes.json";
import { useNavigate } from "react-router-dom";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";
import StartOverBackDrop from "../Components copy/StartOverBackDrop";
import icon from "../Components copy/assets/Images/iconnew.svg";
import BackDrop from "../Components copy/BackDrop";

const schema = Yup.object().shape({
  partnercode: Yup.string()
    .required("Partner Code is Required")
    .matches(
      /^[A-Z]{3}\d{2}$/,
      "Invalid Partner Code. Must be in the format ABC87"
    ),
});

export default function GeneratePartnerCode() {
  const navigationData:any = routesData;
  const [completedStages, setCompletedStages] = useState<any>();
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setloading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [prefilldata, setPrefillData] = useState("");
  const [prfillLoading, setPrefillLoading] = useState(false);
  const [backdrop, setBackDrop] = useState(false);
  const navigate = useNavigate();
  const handleOtp = (newValue: any) => {
    setOtp(newValue);
  };

  useEffect(() => {
    let obj: any = {
      stage: "code_generation",
    };
    setPrefillLoading(true);

    stageDetailsAPICall(obj)
      .then((response: any) => {
        console.log(
          "response.data.completed_stages",
          response.data.completed_stages
        );
        setCompletedStages(response.data.completed_stages);
        if (response.data.data.StageDetails.ClientCode) {
          setPrefillData(response.data.data.StageDetails.ClientCode);
        }
        setPrefillLoading(false);

        if (response.data.data.StageDetails.ErrorMessage) {
          setRejectMessage(response.data.data.StageDetails.ErrorMessage);
        }
      })
      .catch((error: any) => {
        setPrefillLoading(false);
        // console.log("error", error);
      });
  }, []);

  const handleGenerateCode = (values: any) => {
    setloading(true);
    let obj: IGeneratePartnerCode = {
      introducer_code: values.partnercode,
    };

    GeneratePartnerCodeAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data);
        setloading(false);
        const responseData = response.data;
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        if (error.response.data.error.message) {
          setErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };
  const handleStartOver = () => {
    if (
      window.confirm(
        "Are you sure you want to restart, on pressing Yes All the Data will be deleted"
      )
    ) {
      setBackDrop(true);
      setstartOverloading(true);
      startOverAPICall()
        .then((response: any) => {
          const responseData = response.data;
          console.log("responseData", response);
          setstartOverloading(false);
          setBackDrop(false);
          navigate("/mobile");
          window.location.reload();
        })
        .catch((error: any) => {
          setBackDrop(false);
          setstartOverloading(false);
        });
    }
  };

  const InitialValues = {
    partnercode: prefilldata,
  };
  return (
    <div className={styles.mainWrapperTop}>
      <StageLayout
        completedStages={completedStages}
        stageName={"Generate Partner Code"}
        navigatePath={"/cameramodule"}
      />
      <ErrorSnackBar message={rejectMessage} />
      {!prfillLoading ? (
        <div className={styles.mainWrapper}>
          <div className={styles.topContainer}>
            <p className={styles.Header}>Introducer Code Generation </p>
            <p className={styles.subText}>
              Enter your own unique Introducer Code to get started. Your
              Introducer Code is a unique identifier.
            </p>
            <p className={styles.subTextMobileMain}>
              Enter your own unique Introducer Code to get started. Your
              Introducer Code is a unique identifier.Choose a code that is easy
              to remember but secure.
            </p>
            <p className={styles.subTextbottom}>
              Choose a code that is easy to remember but secure.
            </p>
          </div>
          <Formik
            validationSchema={schema}
            initialValues={InitialValues}
            onSubmit={(values: any) => {
              // console.log("values", values);
              handleGenerateCode(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,

              setFieldValue,
            }) => {
              // console.log("errors", errors);
              // console.log("values", values);
              return (
                <form noValidate onSubmit={handleSubmit}>
                  <div className={styles.inputBlocknew}>
                    <p className={styles.instructiontext}>Instructions</p>
                    <p className={styles.egtext}>
                      Please Enter Your Own Partner Code (eg:ABC87)
                    </p>
                    <MuiOtpInput
                      length={5}
                      
                      value={values.partnercode.toUpperCase()}
                      //   name="partnercode"
                      onChange={(newValue: any) => {
                        setFieldValue("partnercode", newValue.toUpperCase());
                      }}
                      sx={{
                        ".MuiOutlinedInput-notchedOutline": {
                          borderRadius: "10px",
                          border: "2px solid #006779",
                        },
                        ".MuiOutlinedInput-input": {
                          padding: "0px !important",
                          height: "60px",
                        },
                      }}
                    />
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {touched.partnercode && errors.partnercode?.toString()}
                    </FormHelperText>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errorMessage}
                    </FormHelperText>
                  </div>

                  <div className={styles.buttonSection}>
                    <LoadingButton
                      className={styles.button}
                      type="submit"
                      variant="contained"
                      loading={loading}
                      id="aadharOpenLinkButton"
                    >
                      Continue
                    </LoadingButton>
                  </div>
                  {backdrop && <StartOverBackDrop />}
                  <div className={styles.startOverSection}>
                    <img src={icon} className={styles.iconImage} />
                    <p className={styles.paratext}>
                      {" "}
                      if the above mentioned info not yours
                      <span
                        className={styles.startoverbutton}
                        onClick={handleStartOver}
                      >
                        Start Over
                      </span>
                    </p>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      ) : (
        <div style={{ height: "85vh" }}>
            <BackDrop />
          </div>
      )}
 
    </div>
  );
}
function setstartOverloading(arg0: boolean) {
  throw new Error("Function not implemented.");
}
